import styled from 'styled-components/macro'

const Line = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid ${props => props.theme.colors.base};
`;

export default Line
